import React from 'react'
import { DocumentTitle } from './DocumentTitle'
import {
  PageTitleContainer,
  PageTitleContent,
  PageTitleIcon,
  PageTitleText,
} from './PageLayout.styles'

export const PageTitle = ({
  title,
  icon,
  noBorder,
  rightContent,
}: {
  title: string
  icon?: React.ReactNode
  noBorder?: boolean
  rightContent?: React.ReactNode
}): JSX.Element => {
  return (
    <PageTitleContainer $noBorder={noBorder}>
      <DocumentTitle title={title} />
      <PageTitleContent>
        {icon && <PageTitleIcon>{icon}</PageTitleIcon>}
        <PageTitleText>{title}</PageTitleText>
      </PageTitleContent>
      {rightContent}
    </PageTitleContainer>
  )
}
